export enum AlertType {
  SuccessRate = 'SuccessRate',
  SuccessRateQuality = 'SuccessRateQuality',
  Duration = 'Duration',
  ErrorRate = 'ErrorRate',
}

export enum AlertStatus { // lowercase, because that's how Grafana sends it
  Alerting = 'alerting',
  Ok = 'ok',
}

export enum LogLevel {
  Info = 'INFO',
  Warn = 'WARN',
  Error = 'ERROR',
  Debug = 'DEBUG',
}

export enum TransactionAction {
  Start = 'START',
  Finish = 'FINISH',
}

export const InternalTransactions = {
  ComponentLoad: 'PANORAMA_COMPONENT_LOAD',
  ComponentPhase: 'PANORAMA_COMPONENT_PHASE',
} as const;

export type PhaseName = string;

export enum Platform {
  Standalone = 'standalone',
  BusinessManager = 'business-manager',
  Viewer = 'viewer',
  Editor = 'editor',
  EditorSettings = 'editor:settings',
  Mobile = 'mobile',
  Standards = 'standards',
}

// This mirrors Sentry severity levels
export enum ErrorSeverity {
  Fatal = 'fatal',
  Error = 'error',
  Warning = 'warning',
  Log = 'log',
  Info = 'info',
  Debug = 'debug',
  Critical = 'critical',
}
